import { useQuery } from "@tanstack/react-query";
import { getUserLocations, UserLocationsFromSN } from "../../../resource/bff";
import { FormOption } from "../component/DeliveryInformationForm/UserDetailForm/UserDetailForm";
import { GURGAON_CITY, GURUGRAM_CITY } from "../../../helper/constant";

type OfficeLocationType = {
  homeLocations: FormOption[];
  workLocations?: FormOption[];
  allHomeOfficeLocations?: FormOption[];
};
const addOptionTitlesAndMerge = (locations: UserLocationsFromSN) => {
  const {
    allLocationsInHomeOfficeCountry = [],
    workLocationAddress,
    homeLocationAddress,
  } = locations;

  const processedPostalCodes = new Set();

  const workLocations = workLocationAddress.map((location) => {
    const { postalCode } = location;
    const isSharedLocation = homeLocationAddress.some(
      (homeLocation) => homeLocation.postalCode === postalCode
    );

    if (isSharedLocation) {
      processedPostalCodes.add(postalCode);
      return {
        ...location,
        optionTitle: `${location.country} - ${location.city} (Home|Working Office)`,
      };
    }

    return {
      ...location,
      optionTitle: `${location.country} - ${location.city} (Working Office)`,
    };
  });

  const homeLocations = homeLocationAddress
    .map((location) => {
      const { postalCode } = location;

      if (!processedPostalCodes.has(postalCode)) {
        return {
          ...location,
          optionTitle: `${location.country} - ${location.city} (Home Office)`,
        };
      }

      return null;
    })
    .filter((location) => location !== null);

  const allHomeOfficeLocations = allLocationsInHomeOfficeCountry.map(
    (location) => ({
      ...location,
      optionTitle: `${location.country} - ${location.city}`,
    })
  );

  if (
    homeLocations.some(
      (location) =>
        location.city === GURGAON_CITY || location.city === GURUGRAM_CITY
    )
  ) {
    return {
      homeLocations,
      workLocations: [],
      allHomeOfficeLocations: [],
    } as OfficeLocationType;
  }

  return {
    homeLocations,
    workLocations,
    allHomeOfficeLocations,
  } as OfficeLocationType;
};

export const useGetUserLocationsFromSNAsync = (ifSendRequest: boolean) => {
  const { isLoading, refetch, error, data, isFetching } = useQuery(
    ["userLocations", ifSendRequest],
    () =>
      getUserLocations().then((res) => {
        return addOptionTitlesAndMerge(res);
      }),
    {
      cacheTime: Infinity,
      enabled: ifSendRequest,
    }
  );

  return {
    isLoading,
    refetch,
    error,
    data,
    isFetching,
  };
};
